import axios from "axios";
import store from "../index";

const state = {
    users: [],
    user: [],


};

const getters = {
    getUsers: state => {
        return state.users;
    },
    getUser: state => {
        return state.user;
    },


};

const actions = {

    asyncFetchUsers: (context) => {

        let url = "auth/all";
        //console.log(context)
        return axios.get(`${context.rootGetters['settings/getUrl']}${url}`,
            {'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`}})

            .then(res => {
                context.commit('setUsers', res.data.data);
            })
            .catch(err => {
                //console.log("errore",err.response.status);
                if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }
                throw Error(err.response.status + ":Posts Not Found");
            });

    },
    saveData: (context, payload) => {
        let url = "auth/register";

        //this.preload = true;
        //this.messages = [];
        //this.setClearError();
        return new Promise((resolve, reject) => {
            context.commit('settings/setErrors', {}, {root: true})
            axios.post(`${context.rootGetters['settings/getUrl']}${url}`,
                payload,
                {'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`}})

                .then(res => {
                    //this.asyncFetchUsers();
                    context.dispatch('asyncFetchUsers')

                    resolve(res.data);


                })
                .catch(err => {
                    console.log(err);
                    const storeError = {
                        'code': err.response.status,
                        'statusText': err.response.statusText,
                        'errors': err.response.data.error,
                        'message': err.response.data.message

                    };
                    //console.log(storeError);
                    context.commit('settings/setErrors', storeError, {root: true})
                    if (err.response.status === 401) {
                        this.$router.push('/login')
                    }
                    reject(storeError)


                });

        })


    },
    createUser: (context, payload) => {
        let url = "auth/create-user";

        return new Promise((resolve, reject) => {
            context.commit('settings/setErrors', {}, {root: true})
            axios.post(`${context.rootGetters['settings/getUrl']}${url}`,
                payload,
                {'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`}})

                .then(res => {

                    context.dispatch('asyncFetchUsers')

                    resolve(res.data);


                })
                .catch(err => {
                    console.log(err);
                    const storeError = {
                        'code': err.response.status,
                        'statusText': err.response.statusText,
                        'errors': err.response.data.error,
                        'message': err.response.data.message

                    };

                    context.commit('settings/setErrors', storeError, {root: true})
                    if (err.response.status === 401) {
                        this.$router.push('/login')
                    }
                    reject(storeError)

                });
        })

    },
    toggleExpired: (context, payload) => {
        let url = "profile/expired";

        return new Promise((resolve, reject) => {
            context.commit('settings/setErrors', {}, {root: true})
            axios.post(`${context.rootGetters['settings/getUrl']}${url}`,
                payload,
                {'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`}})

                .then(res => {
                    context.dispatch('asyncFetchUsers')

                    resolve(res.data);

                })
                .catch(err => {
                    console.log(err);
                    const storeError = {
                        'code': err.response.status,
                        'statusText': err.response.statusText,
                        'errors': err.response.data.error,
                        'message': err.response.data.message

                    };

                    context.commit('settings/setErrors', storeError, {root: true})
                    if (err.response.status === 401) {
                        this.$router.push('/login')
                    }
                    reject(storeError)

                });
        })

    },
    // reset della verifica in due passaggi di un utente (solo SuperAdmin): true se riuscito
    resetTwoFactor: (context, payload) => {
        return axios.post(`${context.rootGetters['settings/getUrl']}auth/2fa/reset`,
            payload,
            {'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`}})
            .then(() => {
                context.dispatch('asyncFetchUsers')
                return true
            })
            .catch(() => false)
    },
    // attiva/disattiva l'utente: un utente non attivo non supera il login (codice 1005)
    toggleActive: (context, payload) => {
        let url = "auth/user/active";

        return new Promise((resolve, reject) => {
            context.commit('settings/setErrors', {}, {root: true})
            axios.patch(`${context.rootGetters['settings/getUrl']}${url}`,
                payload,
                {'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`}})

                .then(res => {
                    context.dispatch('asyncFetchUsers')

                    resolve(res.data);

                })
                .catch(err => {
                    console.log(err);
                    const storeError = {
                        'code': err.response.status,
                        'statusText': err.response.statusText,
                        'errors': err.response.data.error,
                        'message': err.response.data.message

                    };

                    context.commit('settings/setErrors', storeError, {root: true})
                    if (err.response.status === 401) {
                        this.$router.push('/login')
                    }
                    reject(storeError)

                });
        })

    },


};

const mutations = {
    setUsers: (state, value) => {
        state.users = value;
    },
    setUser: (state, value) => {
        state.user = value;
    },

};


export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
